module.exports = __webpack_public_path__ + "img/section02-img01.4ca3fb22.png";